import { Badge, Icon, IconName } from '@usealloy/component-library';

/**
 * Ideally, this component would not be placed at this location. Instead, we could
 * have each component build its own DropdownOptions and supply them to BaseNode.
 * That is the direction we eventually want to go in but it's not refactoring right now.
 */
export default function SnippetVersionBadge({ versionNumber }: { versionNumber: number }) {
  return (
    <Badge status="success">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Icon size="small" icon={IconName.Book} />
        v{versionNumber}
      </div>
    </Badge>
  );
}
